export default __webpack_public_path__ + "static/media/jeep.07f9cc99.svg";